import { render, staticRenderFns } from "./BuildingBulkUpdater.vue?vue&type=template&id=a6f61de6&scoped=true"
import script from "./BuildingBulkUpdater.vue?vue&type=script&lang=ts"
export * from "./BuildingBulkUpdater.vue?vue&type=script&lang=ts"
import style0 from "./BuildingBulkUpdater.vue?vue&type=style&index=0&id=a6f61de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f61de6",
  null
  
)

export default component.exports